'use client';

import { useCallback } from 'react';

import { useCurrentUserId } from '@ps/ui/contexts/auth';

import { useCommunityContext } from '../contexts/community/useCommunityContext';
import { toggleBookmarkMessage } from '../functions/message/toggleBookmarkMessage';

/**
 * Toggle bookmark/un-bookmark on a message. Callers pass the
 * current state (typically from `useMyMessageBookmarks(...).has(id)`)
 * so we know which direction to send.
 */
export function useToggleBookmarkMessage({
  channelId,
  messageId,
}: {
  channelId: string | null | undefined;
  messageId: string | null | undefined;
}) {
  const { creatorId } = useCommunityContext();
  const currentUserId = useCurrentUserId();
  return useCallback(
    async ({ currentlyBookmarked }: { currentlyBookmarked: boolean }) => {
      if (!creatorId || !currentUserId || !channelId || !messageId) return;
      await toggleBookmarkMessage({
        creatorId,
        channelId,
        messageId,
        remove: currentlyBookmarked,
      });
    },
    [creatorId, currentUserId, channelId, messageId],
  );
}
